import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
    const { language, changeLanguage } = useLanguage();
    const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem('token');

    const toggleLanguageMenu = () => {
        setIsLanguageMenuOpen(!isLanguageMenuOpen);
    };

    const handleChangeLanguage = (lang) => {
        changeLanguage(lang);
        setIsLanguageMenuOpen(false);
    };

    const displayLanguage = language === 'fa' ? 'FA' : 'EN';

    const handleSmoothScroll = (e, sectionId) => {
        e.preventDefault();

        // Eğer ana sayfada değilsek, önce ana sayfaya git
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    const headerOffset = 100;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
            }, 100);
            return;
        }

        const element = document.getElementById(sectionId);
        if (element) {
            const headerOffset = 100;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        }
    };

    const handleBlogNavigate = (e) => {
        e.preventDefault();
        navigate('/blogs');
    };

    const handleHomeNavigate = (e) => {
        e.preventDefault();
        navigate('/');
    };

    const handleAuthNavigate = () => {
        if (token) {
            localStorage.removeItem('token');
            navigate('/');
        } else {
            navigate('/auth');
        }
    };

    // Dil değişkenine göre link metinleri
    const scrollNavItems = [
        {
            name: language === 'fa' ? 'معرفی' : 'About',
            id: 'philosophy'
        },
        {
            name: language === 'fa' ? 'خدمات' : 'Services',
            id: 'services'
        },
        {
            name: language === 'fa' ? 'ارتباط با ما' : 'Contact Us',
            id: 'contact'
        }
    ];

    return (
        <nav className="w-full bg-white/80 backdrop-blur-sm sticky top-0 z-50 border-b font-iransansRegular border-gray-100">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 py-4">
                <div className="flex items-center justify-between">
                    {/* Logo */}
                    <a href="/"><img src="/logo.svg" alt="Logo" className="h-8 sm:h-10 w-auto" /></a>


                    {/* Navigation Links - Desktop */}
                    <div className="hidden md:flex gap-8 lg:gap-12">
                        {/* صفحه اصلی / Home */}
                        <a
                            href="/"
                            onClick={handleHomeNavigate}
                            className="text-[#204286] text-lg font-medium hover:text-[#2c5aa6] transition-colors duration-200"
                        >
                            {language === 'fa' ? 'صفحه اصلی' : 'Home'}
                        </a>

                        {/* Scroll yapacak linkler */}
                        {scrollNavItems.map((item) => (
                            <a
                                key={item.id}
                                href={`#${item.id}`}
                                onClick={(e) => handleSmoothScroll(e, item.id)}
                                className="text-[#204286] text-lg font-medium hover:text-[#2c5aa6] transition-colors duration-200"
                            >
                                {item.name}
                            </a>
                        ))}

                        {/* اخبار / News */}
                        <a
                            href="/blogs"
                            onClick={handleBlogNavigate}
                            className="text-[#204286] text-lg font-medium hover:text-[#2c5aa6] transition-colors duration-200"
                        >
                            {language === 'fa' ? 'اخبار' : 'News'}
                        </a>
                    </div>

                    {/* Right Side Items */}
                    <div className="flex items-center gap-4 sm:gap-6">
                        {/* Auth Button */}
                        <button
                            onClick={handleAuthNavigate}
                            className="hidden md:block text-[#204286] text-base font-medium hover:text-[#2c5aa6] transition-colors duration-200"
                        >
                            {token
                                ? (language === 'fa' ? 'خروج از حساب کاربری' : 'Logout')
                                : (language === 'fa' ? 'ثبت‌نام/ ورود' : 'Login/Register')}
                        </button>

                        {/* اخبار / News - Mobil */}
                        <a
                            href="/blogs"
                            onClick={handleBlogNavigate}
                            className="text-[#204286] text-base md:hidden block font-medium hover:text-[#2c5aa6] transition-colors duration-200"
                        >
                            {language === 'fa' ? 'اخبار' : 'News'}
                        </a>

                        {/* Language Selector */}
                        <div className="relative">
                            <button
                                onClick={toggleLanguageMenu}
                                className="text-[#204286] text-base font-medium hover:text-[#2c5aa6] transition-colors duration-200 flex items-center gap-1"
                            >
                                <svg
                                    className={`w-4 h-4 transition-transform duration-200 ${isLanguageMenuOpen ? 'rotate-180' : ''}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                                {displayLanguage}
                            </button>

                            {isLanguageMenuOpen && (
                                <>
                                    <div
                                        className="fixed inset-0 z-40"
                                        onClick={() => setIsLanguageMenuOpen(false)}
                                    />
                                    <div className="absolute top-full mt-2 w-24 bg-white rounded-lg shadow-lg border border-gray-100 py-1 z-50">
                                        <button
                                            onClick={() => handleChangeLanguage('fa')}
                                            className={`w-full px-4 py-2 text-sm hover:bg-gray-50 transition-colors duration-200 ${language === 'fa' ? 'text-[#204286] font-semibold bg-gray-50' : 'text-gray-700'}`}
                                        >
                                            FA
                                        </button>
                                        <button
                                            onClick={() => handleChangeLanguage('en')}
                                            className={`w-full px-4 py-2 text-sm hover:bg-gray-50 transition-colors duration-200 ${language === 'en' ? 'text-[#204286] font-semibold bg-gray-50' : 'text-gray-700'}`}
                                        >
                                            EN
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Header;